import { Injectable } from '@angular/core';
import {
  HttpRequestBuilder,
  HttpRequestMethod,
  HttpResponseContent,
} from '../../core';
import { OneHttpClientService } from '../lib/http';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { ObjectUtils } from '..';
import { DocumentRepositoryModule } from './document.module';
import { DocumentSearchModel } from './model/document-search.model';
import * as Model from './model';
import { RootObjectType } from './model/root-object-type.enum';

@Injectable({
  providedIn: DocumentRepositoryModule,
})
export class DocumentRepository {
  public static readonly RESOURCE = {
    rootDocumnet: '/v1/documents',
  };

  private _reqDocument = new HttpRequestBuilder(
    DocumentRepository.RESOURCE.rootDocumnet
  );

  constructor(private _http: OneHttpClientService) {}

  getDocumentFile(documentId: string): Observable<HttpResponse<Blob>> {
    return this._http.call<Blob>(
      this._reqDocument
        .api()
        .path(documentId)
        .responseType(HttpResponseContent.Blob)
    );
  }

  uploadDocument(file: File): Observable<Model.Document> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    const request = this._reqDocument
      .api()
      .method(HttpRequestMethod.POST)
      .body(formData);
    return ObjectUtils.CreateObjectRequest(this._http, request);
  }

  getDocuments(
    params: DocumentSearchModel
  ): Observable<HttpResponse<Model.Document[]>> {
    const request = this._reqDocument.api();
    Object.getOwnPropertyNames(params).forEach((val) => {
      request.query(val, params[val as keyof Model.DocumentSearchModel]!);
    });
    return this._http.call<Model.Document[]>(request);
  }
}
